import { PiPlayFill } from 'react-icons/pi';
import { motion } from 'framer-motion';


export function Keynotes() {
  return (
    <section id="keynotes" className="relative border-t border-zinc-200 pt-12 md:pt-12">
      <div className="mx-auto flex flex-col">
        {/* Left: Heading */}
        <div className="p-6 md:pb-8 border-b md:border-b-0 md:border-r border-zinc-200 bg-white">
          <div className="sticky top-24">
            <p className="text-sm font-mono text-orange-500 mb-1">
              &lt;Connect 2025 /&gt;
            </p>
            <h2 className="section-heading">Keynotes On Demand</h2>
            <p className="text-gray-600 mt-4 text-md">
                Relive the magic! Watch all the keynotes anytime, anywhere.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-0">
              <motion.a
                key={2}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4 }}
                href="https://events.www.cloudflare.com/Connect2025/sign-in?rId=7949945"
                target='_blank'
                className="relative border-b border-zinc-200 cursor-pointer group mx-4 md:ml-6 md:mr-3"
                aria-label="Watch keynote on YouTube (opens in a new tab)"
              >
                <img src="/keynote.png" alt="Keynote 1" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white transition-all duration-300 z-10 bg-black/20 rounded-full p-6 border border-transparent group-hover:border-black/10 backdrop-blur-sm hover:bg-black/30 scale-[0.8] md:scale-100">
                  <PiPlayFill className='w-12 h-12' />
                </div>
                <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </motion.a>
              <motion.a
                key={2}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4 }}
                href="https://events.www.cloudflare.com/Connect2025/sign-in?rId=7949945"
                target='_blank'
                className="relative border-b border-zinc-200 cursor-pointer group mx-4 md:ml-3 md:mr-6"
                aria-label="Watch keynote on YouTube (opens in a new tab)"
              >
                <img src="/keynote2.png" alt="Keynote 2" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white transition-all duration-300 z-10 bg-black/20 rounded-full p-6 border border-transparent group-hover:border-black/10 backdrop-blur-sm hover:bg-black/30 scale-[0.8] md:scale-100">
                  <PiPlayFill className='w-12 h-12' />
                </div>
                <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </motion.a>
        </div>
      </div>
    </section>
  );
}

export default Keynotes;
